<template>
  <div>
    <organisation-empty v-if="organisation === null" />
    <template v-else>
      <el-row type="flex" class="flex-wrap" :gutter="30">
        <el-col :md="12">
          <div class="ra-page--section">
            <div class="ra-page--section__title">
              <h5>Organisations</h5>
            </div>
            <el-row type="flex" :gutter="20">
              <el-col :md="12">
                <ra-summary-card
                  class="fund"
                  label="Organisation"
                  :value="organisation ? organisation.name : ''"
                >
                  <el-button
                    v-if="userCan('auth', 'organisation.getone')"
                    type="success"
                    icon="ra-icon--arrow-right"
                    circle
                    size="medium"
                    @click="$router.push({ name: 'organisation.index' })"
                  />
                </ra-summary-card>
              </el-col>
              <el-col :md="12">
                <ra-summary-card
                  class="fund"
                  label="Wallet Balance"
                  :value="walletPermission.balance"
                >
                  <el-button
                    v-if="walletPermission.fund"
                    type="success"
                    circle
                    icon="ra-icon--plus"
                    size="medium"
                    @click="showFundWallet = true"
                  />
                </ra-summary-card>
              </el-col>
            </el-row>
            <el-row type="flex" class="mt-2">
              <el-col :span="24">
                <organisation-invites />
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :md="12">
          <div class="ra-page--section">
            <div class="ra-page--section__title">
              <h5>Products</h5>
            </div>
            <el-row type="flex" :gutter="30">
              <el-col
                v-for="(product, index) in products"
                :key="index"
                :md="12"
              >
                <product-card :product="product" />
              </el-col>
            </el-row>
            <el-row v-if="showLogs" type="flex" class="mt-2">
              <el-col :span="24">
                <verifications-by-type />
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <fund-wallet :show.sync="showFundWallet" />
    </template>
  </div>
</template>

<script>
import OrganisationEmpty from "@/components/Home/OrganisationEmpty.vue";
import ProductCard from "@/components/Home/ProductCard";
import OrganisationInvites from "@/components/Organisation/OrganisationInvites.vue";
import VerificationsByType from "@/components/Products/VerifyIdentity/Verifications/VerificationsByType";
import FundWallet from "@/components/Wallet/Fund";

import {
  currentUser,
  getActiveOrganisationWallet,
  isOrganisationActive,
  isProductAccessible
} from "@/lib/utils";
import apiConstants from "@/apiConstants.js";

export default {
  name: "Home",
  components: {
    OrganisationEmpty,
    FundWallet,
    OrganisationInvites,
    ProductCard,
    VerificationsByType
  },

  data() {
    return {
      products: [
        {
          name: "verify-id",
          page: "verify-identity",
          label: "Verify Identity",
          description: "Easily manage and verify your users identity.",
          icon: "check-circle"
        },
        {
          name: "authx",
          page: "authx",
          label: "AuthX",
          description: "Create the simplest onboarding flow in seconds.",
          icon: "lock"
        }
      ],
      loading: false,
      paymentReference: "",
      showFundWallet: false,
      isOrganisationActive: isOrganisationActive()
    };
  },

  computed: {
    organisation() {
      return this.$store.getters.organisation.summary;
    },
    wallet() {
      return this.$store.getters.wallet.balance;
    },
    walletPermission() {
      return {
        balance: this.userCan("payment", "wallet.getall")
          ? this.formatPrice(this.wallet)
          : "XXXXXX",
        fund: this.userCan("payment", "payment.init")
      };
    },
    showLogs() {
      const isVerifyId =
        isOrganisationActive() &&
        isProductAccessible("verify-id") &&
        this.userCan("proxy", "service.logs.all");
      return isVerifyId && this.$store.getters.switch_key;
    }
  },

  mounted() {
    this.paymentReference = this.$route.query && this.$route.query.reference;

    if (currentUser() && this.paymentReference) {
      this.confirmPayment();
    }
  },

  methods: {
    getWallet() {
      if (!this.userCan("payment", "wallet.getall")) {
        return;
      }
      getActiveOrganisationWallet(this.$http)
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    },
    confirmPayment() {
      const body = {
        reference: this.paymentReference
      };
      this.$http
        .post(
          "payments/confirm",
          {
            body: body,
            method: "POST"
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.PAYMENT
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.getWallet();
            this.notification(
              "Confirmed",
              "Payment confirmed successfully",
              "success"
            );
            this.$router.push({ name: "home.index" });
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.ra-page--section {
  &__title {
    margin-bottom: 30px;

    h5 {
      font-size: 1.125rem;
      font-weight: 500;
      opacity: 0.5;
    }

    p {
      font-size: 0.87rem;
      opacity: 0.74;
    }
  }
}

.ra-summary--card.fund {
  height: 100%;
}
</style>
